'use client';

import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS, Node } from '@contentful/rich-text-types';
import { RichTextTableProps } from './types';
import { getColorway } from 'utils/styles';
import { renderTable } from './nodes/Table';
import { renderTableRow } from './nodes/TableRow';
import renderEmbeddedEntry from '../../nodes/EmbeddedEntry';
import { useDisclosureNumberingMap } from 'contexts/DisclosureProvider';

const DEFAULT_HIGHLIGHTED_COLUMN_INDEX = 2; // 1-based from Contentful: 2 = second column (Chime, index 1);

const RichTextTable = ({
  content,
  color,
  highlightedColumnIndex,
  highlightColor,
  mobileDropdownVariant,
}: RichTextTableProps) => {
  const disclosureNumberingMap = useDisclosureNumberingMap();
  const contentfulColumn = highlightedColumnIndex ?? DEFAULT_HIGHLIGHTED_COLUMN_INDEX;
  const highlightedColumn = contentfulColumn - 1; // Contentful 1-based → 0-based index

  const options = {
    renderNode: {
      [BLOCKS.TABLE]: (node: Node, children: React.ReactNode) =>
        renderTable(node, children, color, highlightedColumn, highlightColor, mobileDropdownVariant),
      [BLOCKS.TABLE_ROW]: (node: Node, children: React.ReactNode) =>
        renderTableRow(node, children, highlightedColumn, highlightColor, getColorway(color)),
      [INLINES.EMBEDDED_ENTRY]: (node: Node, children: React.ReactNode) =>
        renderEmbeddedEntry(node, children, content, disclosureNumberingMap),
    },
    renderMark: {
      [MARKS.ITALIC]: (text: React.ReactNode) => <span className="text-xs">{text}</span>,
    },
  };

  return documentToReactComponents(content.json, options);
};

export default RichTextTable;
